import React from 'react'
import { __BookStatus } from '../../../../common/Dictionaries.js';
import StatusItem from '../../../Common/StatusBar/StatusItem';
 
function StatusHeaderItem(props) {

    //Parametros de entrada.
    const inputParam_StatusIndex = props.index;
    const inputParam_StatusId = props.statusId;

    
    //Parametros de componente.
    const bookStatusList = __BookStatus;
    const bookStatusItem = bookStatusList.find(x => x.key === inputParam_StatusId)

    //Funciones de componente.

    //Eventos de componente.

    //Render de componente.
    return (
        <ol className="steps step-no-status-bar pb-2">
            <StatusItem
                index={ inputParam_StatusIndex }
                status={ bookStatusItem }
                statusId={ inputParam_StatusId }
                showLabel={ false }
            />
        </ol>
    );
}

export default StatusHeaderItem;
